import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import ModalHeader from '@components/modals/ModalHeader';
import ModalContainer from '@components/modals/ModalContainer';
import { toastError } from '@components/Toast';

import { renderCreatableDropdown } from '@features/material-requisition/components/index';
import {
	useLazyFetchFabricDetailsByIdQuery,
	useLazyFetchMaterialDetailListQuery,
	useLazyFetchTrimsOrAccessoriesDetailsByIdQuery
} from '@features/material-requisition/api/materialRequisitionApi';
import Fabric from '@features/materials/components/Fabric';
import TrimsAndAccessories from '@features/materials/components/TrimsAndAccessories';
import MaterialInventory from '@features/materials/components/MaterialInventory';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { enumObj, getConsumptionByKeyNameWise, MATERIAL_TITLE_NAME } from '@utils/MaterialsUtil';

const UpdateInventory = ({ onCloseModal, selectedRequisition, callBack }) => {
	const [fetchMaterialList] = useLazyFetchMaterialDetailListQuery();
	const [fetchFabricDetails] = useLazyFetchFabricDetailsByIdQuery();
	const [fetchTrimsOrAccessoriesDetailsById] = useLazyFetchTrimsOrAccessoriesDetailsByIdQuery();
	const [addNewRequisitionType, setAddNewRequisitionType] = useState(null);
	const [selectedItem, setSelectedItem] = useState(null);
	const [consumptionUnit, setConsumptionUnit] = useState(null);
	const [isShowUpdateInventory, setIsShowUpdateInventory] = useState(false);
	const dispatch = useDispatch();

	const promiseOptions = (inputValue) => {
		return new Promise(async (resolve) => {
			try {
				const data = await fetchMaterialList({
					search: inputValue,
					requisitionType: selectedRequisition.requisitionType
				}).unwrap();
				resolve(data);
			} catch {
				toastError('Failed to fetch material list');
				resolve([]);
			}
		});
	};

	const onCreateOption = () => {
		setAddNewRequisitionType(selectedRequisition.requisitionType);
	};

	const onItemClick = async (item) => {
		let requisitionType = selectedRequisition.requisitionType;

		const getConsumptionUnit = (data) => {
			if (requisitionType === 'FABRIC') {
				setConsumptionUnit(getConsumptionByKeyNameWise(data?.fabricType, 'unit'));
			} else if (['TRIMS', 'ACCESSORIES'].includes(requisitionType)) {
				setConsumptionUnit(data?.subCategoryType?.consumptionUnit);
			}
		};

		try {
			dispatch(openLoader());
			const data =
				requisitionType === 'FABRIC'
					? await fetchFabricDetails({ materialId: item.value }).unwrap()
					: await fetchTrimsOrAccessoriesDetailsById({
							materialId: item.value,
							materialType: requisitionType
						}).unwrap();
			getConsumptionUnit(data);
			setSelectedItem(data);
			setIsShowUpdateInventory(true);
		} catch {
			toastError('Failed to fetch material details');
		} finally {
			dispatch(closeLoader());
		}
	};

	return (
		<>
			<ModalContainer>
				<div className="popup-wrapper">
					<div className="common-popup material-request-details-modal">
						<ModalHeader title="Update Inventory" onClose={onCloseModal} />
						<div className="common-popup-body">
							<div className="choose-purpose-box">
								<div className="row">
									{renderCreatableDropdown(
										promiseOptions,
										onCreateOption,
										onItemClick,
										'col-md-12'
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</ModalContainer>
			{addNewRequisitionType === 'FABRIC' && (
				<Fabric
					materialData={undefined}
					isShow={true}
					onclose={onCloseModal}
					viewType={''}
					renderFrom={'MATERIAL'}
					isAdd={true}
					setSelectedBalance={() => false}
					setSelectedSort={() => false}
				/>
			)}
			{addNewRequisitionType === 'TRIMS' && (
				<TrimsAndAccessories
					isAdd={true}
					renderFrom={enumObj.MATERIAL}
					viewType={''}
					title={MATERIAL_TITLE_NAME.TRIMS}
					isShow={true}
					onclose={onCloseModal}
				/>
			)}
			{addNewRequisitionType === 'ACCESSORIES' && (
				<TrimsAndAccessories
					isAdd={true}
					renderFrom={enumObj.MATERIAL}
					viewType={''}
					title={MATERIAL_TITLE_NAME.BRANDING}
					isShow={true}
					onclose={onCloseModal}
				/>
			)}
			{isShowUpdateInventory && selectedItem.id && (
				<MaterialInventory
					materialData={selectedItem}
					onclose={onCloseModal}
					viewType={'updated'}
					isReceiveTabSelected={true}
					consumptionUnit={consumptionUnit}
					requisitionId={selectedRequisition.id}
					callBack={callBack}
				/>
			)}
		</>
	);
};

export default UpdateInventory;
